export default __webpack_public_path__ + "static/media/CareLogin-min.db130752.png";